import React from "react";
import { withTranslationReady } from "../../../../common/i18n/withTranslationReady";
import { Trans, WithTranslation } from "react-i18next";
import { Typography } from "uiLibrary/designSystem/Typography/Typography";

export interface HomeTabProps {
  name: string;
}

const HomeTab = ({ name }: HomeTabProps & WithTranslation) => {
  return (
    <div data-testid={"home-component"} className={"home-tab"}>
      <Typography
        category={"Headline"}
        size={100}
        weight={"Heavy"}
        data-testid={"welcome-user"}
        className={"home-tab__welcome"}>
        <Trans i18nKey={"generic:welcome-user"} values={{ name }} />
      </Typography>
      <Typography
        category={"Paragraph"}
        size={100}
        weight={"Light"}
        data-testid={"no-tasks"}
        className={"home-tab__no-tasks"}>
        <Trans i18nKey={"generic:no-tasks"} />
      </Typography>
    </div>
  );
};

export default withTranslationReady(["generic"])(HomeTab);
